<template>
	<v-card>
		<v-card-title
			class="d-flex align-center"
		>
			<v-icon
				icon="$cashMultiple"
				start
			/>
			<translate>Financial</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-table>
						<thead>
							<tr>
								<th />
								<th>
									<translate>Damage</translate>
								</th>
								<th>
									<translate>Loss/Theft</translate>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th>
									<translate>Deductible</translate>
								</th>
								<td>
									{{ transformToCurrency(orderrow.damage) }}
								</td>
								<td>
									{{ transformToCurrency(orderrow.loss) }}
								</td>
							</tr>
						</tbody>
					</v-table>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-table>
						<thead>
							<tr>
								<th class="text-left">
									<translate>Total</translate>
								</th>
								<th class="text-left">
									<translate>Amount</translate>
								</th>
							</tr>
						</thead>
						<tbody v-if="orderrow.maxCoverage">
							<tr>
								<td>
									<translate>Maximum Coverage</translate>:
								</td>
								<td>
									{{ transformToCurrency(orderrow.maxCoverage) }}
								</td>
							</tr>
							<tr>
								<td>
									<translate>Total Claimed Damages</translate>:
								</td>
								<td>
									{{ transformToCurrency(orderrow.claimedDamages) }}
								</td>
							</tr>
							<tr>
								<td>
									<translate>Remaining Coverage for New Claims</translate>:
								</td>
								<td>
									{{ transformToCurrency(orderrow.maxCoverage - orderrow.claimedDamages) }}
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td>
									<translate>This device did not have a purchase price to compare against.  Feature coming soon.</translate>
								</td>
							</tr>
						</tbody>
					</v-table>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	displayError,
} from 'laravel-front-library';
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'FinancialTable',
	props: {
		orderrowId: {
			type: Number,
			required: true
		}
	},

	data () {
		return {
			orderrow: {
			}
		};
	},

	mounted () {
		this.getOrderrow();
	},

	methods: {
		/**
		 * Retrieve orderrow information
		 */
		getOrderrow () {
			axios.get(`/api/v0/orderrows/financial?id=${this.orderrowId}`)
				.then(({
					data
				}) => {
					this.orderrow = data;
				}).catch((error) => {
					displayError(error.message);
					window.captureException(error);
				});
		},

		/**
		 * @param {string} amount
		 * @returns {string}
		 */
		transformToCurrency (amount) {
			const eurFormatter = new Intl.NumberFormat('nl', {
				style: 'currency',
				currency: 'EUR',
			});

			return eurFormatter.format(Number(amount));
		},
	}
};
</script>
